import { render } from "./BoxHistoricShow.vue?vue&type=template&id=dafbff64&scoped=true"
import script from "./BoxHistoricShow.vue?vue&type=script&lang=js"
export * from "./BoxHistoricShow.vue?vue&type=script&lang=js"

import "./BoxHistoricShow.vue?vue&type=style&index=0&id=dafbff64&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dafbff64"]])

export default __exports__